import { render, staticRenderFns } from "./BannerZone.vue?vue&type=template&id=6f10aa4e&scoped=true&"
import script from "./BannerZone.vue?vue&type=script&lang=js&"
export * from "./BannerZone.vue?vue&type=script&lang=js&"
import style0 from "./BannerZone.vue?vue&type=style&index=0&id=6f10aa4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f10aa4e",
  null
  
)

export default component.exports